import type { AddItemContext, CartStateGetSet } from "@/cart/types";
import { MATIC_BUILDER_KIT_VARIANT_ID } from "@/consts/shopify";
import { getCartLines } from "@/cart/displayCart";
import { isBuilderKitVariantId } from "@/utils/builderKit";

export const addBuilderKit = ({ get }: CartStateGetSet) => {
  return async (context?: AddItemContext) => {
    const existingKitLine = getCartLines(get().cart).find((line) =>
      isBuilderKitVariantId(line.merchandise.id),
    );

    if (existingKitLine) {
      return get().cart;
    }

    await get().addItem(MATIC_BUILDER_KIT_VARIANT_ID, context, 1);
    return get().cart;
  };
};
